var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMxIconSquareCheckmarkSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3C0 1.34315 1.34315 0 3 0H15C16.6569 0 18 1.34315 18 3V15C18 16.6569 16.6569 18 15 18H3C1.34315 18 0 16.6569 0 15V3ZM13.1574 5.87699C12.6843 5.37434 11.904 5.37434 11.4309 5.87699L8.05882 9.4598L6.56912 7.87699C6.09603 7.37434 5.31573 7.37434 4.84265 7.87699C4.38578 8.36241 4.38578 9.13759 4.84265 9.62301L7.19559 12.123C7.66867 12.6257 8.44898 12.6257 8.92206 12.123L13.1574 7.62301C13.6142 7.13759 13.6142 6.36241 13.1574 5.87699Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMxIconSquareCheckmarkSolid);
export default __webpack_public_path__ + "static/media/mxIconSquareCheckmarkSolid.24aab3d9742be81b9ce138eef957cd68.svg";
export { ForwardRef as ReactComponent };